import LoaderImg from "../assets/images/loader.gif";

const Loader = () => (
  <div className="loader-container">
    <div className="loader-block">
      <img src={LoaderImg} alt="Loading..." />
    </div>
  </div>
);

export default Loader;
